export default defineNuxtRouteMiddleware((to) => {
  const segments = to.path.split('/').filter(Boolean)
  const lastSegment = segments.at(-1)

  const paramValues = Object.values(to.params).map(String)

  if (paramValues.includes(lastSegment)) {
    const defaultTabs = {
      transactions: 'transaction',
      blocks: 'block',
      accounts: 'transactions',
      tokens: 'transfers',
      nfts: 'transfers'
    }

    const base = segments[0]
    const defaultTab = defaultTabs[base]
    if(!defaultTab) {
      return
    }
    return navigateTo(`${to.path}/${defaultTab}`)
  }
})